import { Button, Modal } from 'antd';
import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getHospitalForPage, makeTrueConsultationStatus } from '../../../BillingProcess/thunk';
import Wrap from './styles';

type Props = {
  facility_id?: string;
  invoice_month: string;
  page: number;
};

const ButtonSelectAll: FC<Props> = ({ facility_id, invoice_month, page }) => {
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const handleSubmit = async () => {
    if (!facility_id) return;
    setModalVisible(false);
    const postSelectAll = async () => {
      const resultAction: any = await dispatch(
        makeTrueConsultationStatus({
          facility_id,
          invoice_month,
        }),
      );
      if (makeTrueConsultationStatus.fulfilled.match(resultAction)) {
        if (resultAction.payload.has_error && resultAction.payload.result.matched > 300) {
          postSelectAll();
        } else if (!resultAction.payload.has_error) {
          dispatch(
            getHospitalForPage({
              facility_id,
              invoice_month,
              page,
              per_page: 50,
            }),
          );
        }
      }
    };
    postSelectAll();
  };

  return (
    <Wrap>
      <Button onClick={() => setModalVisible(true)} className="btn-register standardFont">
        全て◯をつける
      </Button>
      <Modal
        title="操作確認"
        centered
        visible={modalVisible}
        onOk={handleSubmit}
        onCancel={() => setModalVisible(false)}
        okText="実行"
        cancelText="キャンセル"
        width={600}
        closable={false}
        maskClosable={false}
        className="modal"
        okButtonProps={{
          type: 'link',
          className: 'ant-btn-primary',
        }}
      >
        <p
          className="middleBoldFont"
          style={{
            textAlign: 'center',
          }}
        >
          未入力の受診状況全てに◯をつけます。よろしいですか。
        </p>
        <p
          style={{
            textAlign: 'center',
            marginBottom: 0,
          }}
        >
          ※既に入力されているものは変更されません。
        </p>
      </Modal>
    </Wrap>
  );
};

export default ButtonSelectAll;
